module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"no-tasks":"No Tasks","unassigned":"Unassigned"},"message":{"no-secondary-equipment-assigned":"No Secondary Equipment Assigned"}},"es":{"message":{"no-secondary-equipment-assigned":"Equipo secundario no ha sido asignado"}}}')
  delete Component.options._Ctor
}
